import axios from "axios";

// Base URL for all API requests.
// - In development this is empty, so relative paths ("/api/v1/...") are handled
//   by the CRA dev proxy (see "proxy" in package.json).
// - In production set REACT_APP_API_URL to the deployed API origin
//   (e.g. https://your-api.onrender.com).
axios.defaults.baseURL = process.env.REACT_APP_API_URL || "";

export default axios;
